export default "__VITE_ASSET__56ec1d00__"